import { BoardContextState } from '@shared/models/boardContextState';
import { createContext } from 'react';

export const BoardContext = createContext<BoardContextState>({
  id: -1,
  isFirst: false,
  isLast: false,
});
